import { DataGrid, GridColDef, GridRowParams } from '@mui/x-data-grid';
import React from 'react';
import { dataGridIdSlots } from 'v2/components/DataGrid/dataGridIdSlots';
import { renderHeaderWithId } from 'v2/components/DataGrid/renderHeaderWithId';
import NoRowsOverlay from 'v2/components/NoRowsOverlay/NoRowsOverlay';
import { TextCell } from 'v2/components/TextCell/TextCell';
import { DATAGRID_DEFAULT_PAGE_SIZE, DATAGRID_PAGE_SIZE_OPTIONS, DATAGRID_ROW_HEIGHT } from 'v2/constants';

interface Row {
  id: string;
  name: string;
}

interface Props {
  rows: Row[];
  headerName: string;
  loading: boolean;
  isHighlighted: (id: string) => boolean;
  onRowClick: (id: string) => void;
  idPrefix?: string;
  noRowsMessage?: string;
}

const SingleColumnDataGrid: React.FC<Props> = ({
  rows,
  headerName,
  loading,
  isHighlighted,
  onRowClick,
  idPrefix,
  noRowsMessage
}) => {
  const columns: GridColDef<Row>[] = [
    {
      field: 'name',
      headerName,
      flex: 1,
      sortable: false,
      renderHeader: renderHeaderWithId(idPrefix),
      renderCell: ({ row }) => <TextCell variant="title">{row.name}</TextCell>
    }
  ];

  return (
    <DataGrid
      className="background-level2"
      rows={rows}
      columns={columns}
      autoHeight
      hideFooter={rows.length <= DATAGRID_DEFAULT_PAGE_SIZE}
      pageSizeOptions={DATAGRID_PAGE_SIZE_OPTIONS}
      initialState={{ pagination: { paginationModel: { pageSize: DATAGRID_DEFAULT_PAGE_SIZE } } }}
      rowHeight={DATAGRID_ROW_HEIGHT}
      loading={loading}
      disableRowSelectionOnClick
      disableColumnMenu
      getRowClassName={(params) => (isHighlighted(params.row.id) ? 'row-highlighted' : '')}
      onRowClick={(params: GridRowParams<Row>) => onRowClick(params.row.id)}
      slots={{
        ...dataGridIdSlots,
        noRowsOverlay: NoRowsOverlay
      }}
      slotProps={{ row: { idPrefix }, cell: { idPrefix }, noRowsOverlay: { message: noRowsMessage } }}
    />
  );
};

export default SingleColumnDataGrid;
